<div class="success-snackbar">
  <span class="message">{{ message }}</span>
</div>
